module.exports = __webpack_public_path__ + "img/img_crm_email.d3a67d19.svg";